<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      :itemNames="['search_proName','create_button',]"
      :columns="columns"
      :queryParams="searchQueryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <a-form-item slot="search_proName" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="searchQueryParams.productName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
        <a-button style="margin-left:15px" @click="openModel">绑定商品</a-button>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除绑定" @confirm="deleteProBind(rowItem.record.id)">
          <a>删除绑定</a>
        </a-popconfirm>
      </span>
    </search-page-view>
    <a-modal title="商品绑定" :width="750" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="所属供应商" prop="galasysAccountId">
          <a-select v-model="ruleForm.galasysAccountId"
                    placeholder="请选择"
                    @change="handleChange" style="max-width: 400px">
            <a-select-option v-for="item in providerList" :key="item.id" :value="item.id">
              {{ item.supplierName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" required>
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span style="margin-left: 10px;">*仅能关联门票类型且未上架的自有产品</span>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.productId" label="商品名称" prop="proId">
          <span style="margin-left: 10px;">{{ ruleForm.productId }} {{ ruleForm.productName }}</span>
        </a-form-model-item>
        <a-form-model-item label="供应商门票名称" prop="galasysProductsIdList">
          <a-select
            v-model="ruleForm.galasysProductsIdList"
            mode="multiple"
            placeholder="请选择"
            option-label-prop="label"
            style="max-width:400px;"
            @change="handleTicketChange"
          >
            <a-select-option v-for="item in supplierTicketList" :key="item.galasysOptionId"
                             :value="item.galasysOptionId" :label="item.galasysOptionName">
              <span role="img" :aria-label="item.galasysOptionName">{{ item.galasysOptionName }}</span>
            </a-select-option>
          </a-select>
          <span style="margin-left: 10px;">*支持多选，提交即更新票型</span>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">保存设置
          </a-button>
        </div>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadProductPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSourceItemClick(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'
import searchForm from '@/utils/mixins/searchFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'GalasysConnection',
  mixins: [searchForm],
  components: { SelectedProductDialog },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      searchQueryParams: {
        productName: ''
      },
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0,
        proStatus: 0,
        proType: 1
      },
      loadPromise: params => this.getListPromise(params),
      loadProductPromise: params => this.getProductListPromise(params),
      columns: [
        {
          title: '商品ID',
          dataIndex: 'productId'
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          width: '25%'
        },
        {
          title: '已关联票型',
          dataIndex: 'galasysOptionName'
        },
        {
          title: '类型',
          dataIndex: 'catalogIdStr'
        },
        {
          title: '更新时间',
          dataIndex: 'gmtModified',
          width: '120px'
        },
        {
          title: '供应商名称',
          dataIndex: 'galasysAccountName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      visible: false,
      showSelectedDialog: false,
      ruleForm: {
        productId: '',//产品ID
        productName: '',
        galasysAccountId: undefined,// 供应商id
        galasysAccountName: '',// 供应商名称
        galasysDirectProducts: [],
        galasysProductsIdList: []
      },
      rules: {
        galasysAccountId: [{ required: true, message: '请选择供应商名称', trigger: 'change' }],
        productId: [{ required: true, message: '请关联商品品', trigger: 'change' }],
        galasysProductsIdList: [
          { required: true, message: '请选择供应商门票名称', trigger: 'change' },
          { validator: this.checkGalasysLimit, trigger: 'change' }
        ]
      },
      providerList: [],
      selectedProduct: {},
      supplierTicketList: [],
      submitLoading: false,
      submitFormData: ''
    }
  },
  computed: {
    ...mapState({
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GalasysConnection', title: '商品绑定' },
      { name: 'GalasysOrderConnection', title: '订单直连' },
      { name: 'GalasysNewAccount', title: '关联账号' }
    ])
  },
  methods: {
    //选择商品
    checkGalasysLimit(rule, value, callback) {
      this.getLogUtils().logWithTag('==checkGalasysLimit==', value)
      if (value.length > 50) {
        callback(new Error('最多添加50个'))
      } else {
        callback()
      }
    },
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('v1/galasys/bind/list', params)
    },
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.selectedProduct = item
      this.ruleForm.productName = item.proName
      this.ruleForm.productId = item.proId
      this.showSelectedDialog = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      let newList = []
      let list = this.submitFormData.galasysProductsIdList
      if (list && list.length > 0) {
        list.forEach(item => {
          const findItem = this.supplierTicketList.find(item2 => item2.galasysOptionId == item)
          if (findItem) {
            this.getLogUtils().logWithTag('findItem', findItem)
            newList.push(findItem)
          }
        })
      }
      this.submitFormData.galasysDirectProducts = newList
      this.getLogUtils().logWithTag('galasysDirectProducts', this.submitFormData.galasysDirectProducts)
      delete this.submitFormData.galasysProductsIdList
      this.getHttpServices().getProService().post('v1/galasys/bind/save-edit', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.visible = false
        this.resetFrom()
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //解除绑定
    deleteProBind(id) {
      this.getHttpServices().getProService().get('v1/galasys/bind/product-delete/' + id).then(res => {
        this.getLogUtils().logWithTag('deleteProBind', res)
        this.$message.success('删除绑定成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取供应商列表
    getProviderList() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      this.getHttpServices().getServerApiService().post('galasys/supplier/all', params).then(res => {
        this.getLogUtils().logWithTag('getProviderList', res)
        if (res && res.length > 0) {
          this.providerList = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //石基环企景区列表
    getGalasyTicketList(id) {
      let params = {
        galasysId: id,
        productName: '',
        limitDto: {
          pageNum: 1,
          pageSize: 100000
        }
      }
      this.getHttpServices().getProService().post('v1/galasys/product/list', params).then(res => {
        this.getLogUtils().logWithTag('getGalasyTicketList', res)
        if (res && res.data && res.data.length > 0) {
          let list = res.data
          let galasysList = []
          list.forEach(item => {
            let galasysObj = {
              galasysAccountId: '',
              galasysAccountName: '',
              productName: '',
              catalogId: '',
              galasysOptionCode: '',//石基环门票商品编码
              galasysOptionId: '',//石基环门票id映射魔方票型id
              galasysOptionName: '',//石基环门票名称映射魔方票型名称
              galasysParkId: '',//石基环景区编码映射魔方产品id
              galasysParkName: ''//石基环景区名称映射魔方产品名称
            }
            galasysObj.galasysOptionCode = item.productCode
            galasysObj.galasysOptionId = item.productID
            galasysObj.galasysOptionName = item.productName
            galasysObj.galasysParkId = item.parkID
            galasysObj.galasysParkName = item.parkName
            galasysList.push(galasysObj)
          })
          this.getLogUtils().logWithTag('galasysList', galasysList)
          this.supplierTicketList = galasysList
        } else {
          this.supplierTicketList = []
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(value) {
      if (value) {
        this.ruleForm.galasysAccountName = this.providerList.filter(item => item.id == value)[0].supplierName
      } else {
        this.ruleForm.galasysAccountName = ''
      }
      this.ruleForm.galasysDirectProducts = []
      this.ruleForm.galasysProductsIdList = []
      this.ruleForm = { ...this.ruleForm }
      this.getGalasyTicketList(value)
      this.getLogUtils().logWithTag('galasysAccountName', this.ruleForm.galasysAccountName)
    },
    handleTicketChange(value) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
    },
    openModel() {
      this.visible = true
      this.resetFrom()
      this.getProviderList()
    },
    handleCancel() {
      this.visible = false
    },
    resetFrom() {
      this.ruleForm = {
        productId: '',//产品ID
        productName: '',
        galasysAccountId: undefined,// 供应商id
        galasysAccountName: '',// 供应商名称
        galasysDirectProducts: []
      }
    }
  }
}
</script>
<style scoped></style>
